import styled from 'styled-components';

export const DivFormContainer = styled.div`
  padding: 3em 1em 6em 1em;
  @media only screen and (min-width: 768px) {
    padding: 0em 1em 1em 1em;
  }
`;



// WEBPACK FOOTER //
// ./src/marketers/styled.js